<div class="h-100 container">
  <div class="h-100 row">
    <div class="col-12">
      <div class="h-100 d-flex flex-column justify-content-center">
        <h2>{{ 'Not allowed' | translate | uppercase }}</h2>
        <p class="mt-4">{{ 'You are not allowed to enter the site. Please, sign in first.' | translate }}</p>
      </div>
    </div>
  </div>
</div>
